import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BlackboxPositionDto, JourneyItemDto, JourneyDetailModel } from 'src/shared/service-proxies/service-proxies';

export interface GoogleLatLon {
  latitude: number;
  longitude: number;
}
export interface GoogleSnappedRoadItem {
  location: GoogleLatLon,
  originalIndex: number;
  placeId: string;
}
export interface GoogleSnappedRoadResult {
  snappedPoints: GoogleSnappedRoadItem[]
}

@Injectable({
  providedIn: 'root'
})
export class RoadsService {

  private url: string = "https://roads.googleapis.com/v1/snapToRoads?key=AIzaSyBbtdwYOxBg-pnwcNSKmIw0O86uBHStozI";

  constructor(private http: HttpClient) { }

  getSnapToRoadsPositions(job: JourneyItemDto, positions: any[]) {
    var url = `${ this.url }&interpolate=true&path=`;
    var isFirst = true;
    positions.forEach(position => {
      if (!isFirst) {
        url += "|";
      }

      url += `${ position.latitude },${ position.longitude }`;
      isFirst = false;
    });

    return this.http.get<GoogleSnappedRoadResult>(url);
   }
  
}
